import styled from 'styled-components';
import { CrossIcon } from 'ui-components/src/components/atoms/icons';

export const Container = styled.div`
  margin: 12px 0 8px 0;
`;

export const Line = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
`;

export const Name = styled.p`
  font-size: 14px;
  font-family: ${({ theme }) => theme.typography.primary.bold};
  margin: 0;
`;

export const Action = styled.button`
  width: 24px;
  height: 24px;
  background: transparent;
  border: 0;
  outline: 0;
  border-radius: 99px;
  padding: 4px;

  &:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.08);
  }
`;

export const DeleteIcon = styled(CrossIcon)`
  fill: ${({ theme }) => theme.colors.primary.cyan};
`;

export const Wrapper = styled.div``;
